<template>
  <div class="nav">
    <router-link class="nav-item" v-for="(item,i) in navList" :key="i" @click.native="toHome(item)" :to="item.path" active-class="active">
      <!-- <img class="img1" :src="item.icon1" alt=""> -->
      <img class="img" :src="item.img" alt="">
      <el-button type="primary" round>立即办理</el-button>
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["navList"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    toHome(e) {
		if(e.path == '/'){
		this.$alert('正在开发中，敬请期待', '提示', {
			confirmButtonText: '确定',
		});
    }
		// this.$emit("toHome", e);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 47px;
  .nav-item {
    width: 815px;
    height: 268px;
    // box-shadow: 0px 3px 6px 0px rgba(102, 102, 102, 0.15);
    border-radius: 20px;
    position: relative;
    img{
      width: 100%;
      height: 100%;
      display: block;
    }
    button{
      position: absolute;
      bottom: 30px;
      left: 57px;
      font-weight: bold;
      font-size: 36px;
      border-radius: 36px;
      padding: 17px 47px;
    }
  }
}
// .active {
//   width: 273px;
//   height: 168px;
//   background: linear-gradient(0deg, #61a4ff 0%, #2d80f0 99%);
//   box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.32);
//   border-radius: 6px;
//   color: #fff;
//   p {
//     color: #fff;
//   }
//   .img1 {
//     display: none;
//   }

//   .img2 {
//     display: block;
//   }

//   &::after {
//     display: none;
//   }
// }
</style>
